import React, { Fragment } from 'react';
import { wrapOptionId } from '../../helpers/strings';
import { optionFind } from '../../helpers/functions';

const FoilColorSwatch = ({
  labelProps, option, mediaUrl, attr,
}) => {
  const fabricOption = optionFind(x => x.id === attr.value, attr.options || []).getOrElseValue({});
  const shouldRenderOutlinedWhiteFoil = option.label === 'white' && !attr.value;
  const swatchWidth = '34px';

  return (
    <Fragment>
      <label className="PDPRedesign--ControlElement" {...labelProps} htmlFor={wrapOptionId(option.id)}>
        <img alt={option.label} src={`${mediaUrl}attribute/swatch/swatch_image/56x56${option.display_label}`} />
      </label>
      <label
        {...labelProps}
        className="PDPRedesign--FoilColor-Swatch"
        htmlFor={wrapOptionId(option.id)}
        style={{
          backgroundImage: `url(${mediaUrl}attribute/swatch/swatch_image/56x56${fabricOption.display_label}?auto=webp)`,
          backgroundSize: 'cover',
          width: swatchWidth,
          height: swatchWidth,
        }}
      >
        <img
          alt={option.label}
          src={`${mediaUrl}attribute/swatch/swatch_thumb/110x90/l/a/pdp-redesign-0827-${option.label}-foil${
            shouldRenderOutlinedWhiteFoil ? '-outlined' : ''
          }.png?auto=webp`}
        />
      </label>
      <div
        style={{
          width: swatchWidth,
          marginTop: '7px',
          borderBottom: '2px solid transparent',
        }}
        className="PDPRedesign--FoilColor-Line"
      />
    </Fragment>
  );
};

export default FoilColorSwatch;



// WEBPACK FOOTER //
// ./src/components/RadioInput/FoilColorSwatch.js